'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMedia;
require('match-media');

function matchMedia(mediaQueryString) {
  return window.matchMedia(mediaQueryString);
}

function getMedia(options) {
  var queries = options.media;

  var media = Object.keys(queries).map(function (name) {
    return { name: name, queryString: queries[name] };
  }).reduce(function (result, media) {
    result[media.name] = matchMedia(media.queryString).matches;
    return result;
  }, {});

  return media;
}
//# sourceMappingURL=getMedia.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/useragent/lib/getMedia.js
// module id = 758
// module chunks = 1